export type UserLevel = 'user' | 'agent' | 'supervisor';

export const AgentWorkStates = [
    'Active',
    'AfterWork',
    'Closed',
    'Lookup',
    'Preview',
] as const;
export type AgentWorkState = (typeof AgentWorkStates)[number];

export const AgentStates = [
    'Busy',
    'Break',
    'Idle',
    'LoggedOut',
    'PendingLogout',
    'PendingBreak',
] as const;
export type AgentState = (typeof AgentStates)[number];

export const AvatarPresences = {
    Break: 'warning',
    Idle: 'success',
    Busy: 'danger',
    LoggedOut: 'secondary',
} as const;

export type AvatarPresence =
    (typeof AvatarPresences)[keyof typeof AvatarPresences];
